module.exports = __webpack_public_path__ + "img/ic-exclamation-ac.12c980ac.svg";